import script from "./boot-optimize.vue?vue&type=script&lang=ts&setup=true"
export * from "./boot-optimize.vue?vue&type=script&lang=ts&setup=true"

import "./boot-optimize.vue?vue&type=style&index=0&id=0bf037d4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf037d4"]])

export default __exports__